import { useQuery } from '@tanstack/react-query';
import { getFaiths } from '@uplift/api';
import { CheckboxGroupOption } from '@uplift/ui-v2';
import { PROFILE_ROW_QUERY_KEYS } from '../profile.utils';
import { PreferenceForm } from './PreferenceForm.component';

export type FaithFormProps = {
  hideLabel?: boolean;
  includePreferNotToSay?: boolean;
};

export const FaithForm: React.VFC<FaithFormProps> = props => {
  const { data: faiths = [] } = useQuery(PROFILE_ROW_QUERY_KEYS.faith, async () => {
    const response = await getFaiths();

    return response.data;
  });

  const normalizedOptions: CheckboxGroupOption[] = faiths.map(({ name, id }) => ({
    label: name,
    value: id,
  }));

  return (
    <PreferenceForm
      name="faiths"
      formOptions={normalizedOptions}
      includePreferNotToSay={props.includePreferNotToSay}
    />
  );
};
